import { inject, Pipe, PipeTransform } from '@angular/core';
import { RollbarService } from '../errors/error-handler.service';

@Pipe({
  name: 'i18nLookup',
  standalone: true,
})
export class I18nLookupPipe implements PipeTransform {
  rollbar = inject(RollbarService);

  transform<T extends object>(value: keyof T, i18nMap: T) {
    if (!(value in i18nMap)) {
      this.rollbar.warn(`Missing i18n label for '${String(value)}'`);
    }
    return i18nMap[value];
  }
}
